import { type FC } from 'react';
import classnames from 'classnames';

import { type FaqItem } from './tradeBenefitsFaqs.tsx';
import { TradeBenefitsAccordionItem } from '../TradeBenefitsAccordionItem.tsx';
import { trackTradeBenefitsEvent } from '../tradeBenefitsTracking.ts';

import dibsCss from 'dibs-css';

type Props = Pick<FaqItem, 'id' | 'question' | 'answer'>;

const TradeBenefitsFaqAccordionItem: FC<Props> = ({ id, question, answer }) => {
    const contentId = `faq-${id}`;

    return (
        <TradeBenefitsAccordionItem
            summary={question}
            variant="medium"
            contentId={contentId}
            contentClassName={classnames(dibsCss.flex, dibsCss.flexCol, dibsCss.gapXxsmall)}
            onOpen={() =>
                trackTradeBenefitsEvent({
                    stepInteractionName: 'faq drawer opened',
                    trigger: contentId,
                })
            }
        >
            {answer}
        </TradeBenefitsAccordionItem>
    );
};

export { TradeBenefitsFaqAccordionItem };
